export function cOLORADOABADREV100626CB() {
return [   // Release 2026-10-08 13:44:55
 {
   page: 0,
 name: "Logo",
 type: "logo",
 top: 28.673,
 left: 53,
 width: 240,
 height: 36,
 }, 
{
   page: 0,
   name: "Client Names Legal", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 106.04,
   left: 126.0,
   width: 433.866,
   height: 11.825
}
,
{
   page: 0,
   name: "Date", 
   fontSize: 9,
   type: "date",
   top: 188.84,
   left: 126.0,
   width: 95.464,
   height: 11.825
}
] }
